import { ONBOARDING_LAUNCH_DATE } from './Onboarding.types';

export const isEligibleForOnboarding = (
  createdAt: Date | string | null,
): boolean => {
  if (!createdAt) return false;

  const createdDate =
    typeof createdAt === 'string' ? new Date(createdAt) : createdAt;

  return createdDate >= ONBOARDING_LAUNCH_DATE;
};
